var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.44 20.63v473.227c43.08-1.258 82.452-26.44 111.833-68.043 30.15-42.69 49.18-102.418 49.18-168.57 0-66.152-19.027-125.88-49.178-168.57C358.895 47.072 319.52 21.89 276.44 20.63zM156.07 227.194c-10.05.02-20.717.973-31.93 2.67-.857 98.74 54.765 57.68 122.387 65.075-14.887-50.39-46.9-67.83-90.457-67.745zm231.46 0c10.05.02 20.717.973 31.93 2.67.855 98.74-54.767 57.68-122.39 65.075 14.887-50.39 46.903-67.83 90.46-67.745z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisibility);
export default __webpack_public_path__ + "static/media/invisibility.6fdd53623078b8e6c29763e95961a1bb.svg";
export { ForwardRef as ReactComponent };